module.exports = __webpack_public_path__ + "static/photocentric-7086abf90146003627150d3f1dac5ab1.png";